import { cB as a, cNotM as l, c as t, cM as o, cE as d } from "./ghl-ui.es384.js";
const r = "0!important", s = "-1px!important";
function i(n) {
  return o(n + "-type", [t("& +", [a("button", {}, [o(n + "-type", [d("border", {
    borderLeftWidth: r
  }), d("state-border", {
    left: s
  })])])])]);
}
function e(n) {
  return o(n + "-type", [t("& +", [a("button", [o(n + "-type", [d("border", {
    borderTopWidth: r
  }), d("state-border", {
    top: s
  })])])])]);
}
const f = a("button-group", `
 flex-wrap: nowrap;
 display: inline-flex;
 position: relative;
`, [l("vertical", {
  flexDirection: "row"
}, [l("rtl", [a("button", [t("&:first-child:not(:last-child)", `
 margin-right: ${r};
 border-top-right-radius: ${r};
 border-bottom-right-radius: ${r};
 `), t("&:last-child:not(:first-child)", `
 margin-left: ${r};
 border-top-left-radius: ${r};
 border-bottom-left-radius: ${r};
 `), t("&:not(:first-child):not(:last-child)", `
 margin-left: ${r};
 margin-right: ${r};
 border-radius: ${r};
 `), i("default"), o("ghost", [i("primary"), i("info"), i("success"), i("warning"), i("error")])])])]), o("vertical", {
  flexDirection: "column"
}, [a("button", [t("&:first-child:not(:last-child)", `
 margin-bottom: ${r};
 margin-left: ${r};
 margin-right: ${r};
 border-bottom-left-radius: ${r};
 border-bottom-right-radius: ${r};
 `), t("&:last-child:not(:first-child)", `
 margin-top: ${r};
 margin-left: ${r};
 margin-right: ${r};
 border-top-left-radius: ${r};
 border-top-right-radius: ${r};
 `), t("&:not(:first-child):not(:last-child)", `
 margin: ${r};
 border-radius: ${r};
 `), e("default"), o("ghost", [e("primary"), e("info"), e("success"), e("warning"), e("error")])])])]);
export {
  f as default,
  s as n1,
  r as zero
};
